import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

// Initialize from URL params on first load only
const getInitialBuildId = (): string | null => {
  const params = new URLSearchParams(window.location.search)
  return params.get('build')
}

export const SidebarAtom = atomWithStorage('sidebarOpen', true)
export const SidebarHoverAtom = atom(false)
export const openChangeClientAtom = atom(false)
export const addLayersDialogAtom = atom(false)
export const buildIdAtom = atom<string | null>(getInitialBuildId())

SidebarAtom.debugLabel = 'NewSidebarAtom'
SidebarAtom.debugLabel = 'SidebarHoverAtom'
openChangeClientAtom.debugLabel = 'openChangeClientAtom'
addLayersDialogAtom.debugLabel = 'addLayersDialogAtom'
buildIdAtom.debugLabel = 'buildIdAtom'
